/* eslint-env browser */

import async from 'async';
import React from 'react';
import Pusher from 'pusher-js';
import { Link } from 'react-router';
import _ from 'lodash';

import axios from '../../lib/AxiosInstance';
import config from '../../../config/config';
import Controls from '../Controls/Controls';
import { DragDropContext } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import Notification from '../Notification/Notification';
import SlideSettingsModal from '../SlideSettingsModal/SlideSettingsModal';
import OverviewModal from '../OverviewModal/OverviewModal';
import ChannelsModal from '../ChannelsModal/ChannelsModal';
import reducerStore from '../../reducers/reducerStore';
import SettingsModal from '../SettingsModal/SettingsModal';
import GeneralSettingsModal from '../GeneralSettingsModal/GeneralSettingsModal';
import Slide from '../Slide/Slide';
import CompetitionSlide from '../Slide/CompetitionSlide';
import SlideIndicator from '../SlideIndicator';
import UpsalesLogo from '../../assets/UpsalesLogo';

import './SalesTv.scss';

class SalesTv extends React.Component {
    static launchPresentationMode() {
        if (document.documentElement.requestFullscreen) {
            document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
            document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
            document.documentElement.webkitRequestFullscreen();
        } else if (document.documentElement.msRequestFullscreen) {
            document.documentElement.msRequestFullscreen();
        }
    }

    // Making sure we are not creating too many slides in the Controls component
    static getUserInfo(cb) {
        axios.get('/api/self').then(data => cb(null, data.data));
    }

    static getMetadata(clientId, cb) {
        axios.get('/api/metadata').then(data => cb(null, data.data));
    }

    static updateSlideData() {
        axios.get('/api/salestv/force-update').then((tvData) => {
            reducerStore.dispatch({
                type: 'SET SLIDES DATA',
                data: tvData.data,
            });
        }).catch((error) => {
            // console.log('error', error);
            throw error;
        });
    }

    static startEditing(editingWidget) {
        reducerStore.dispatch({ type: 'EDITING WIDGET', editingWidget });
    }

    static stopEditing() {
        reducerStore.dispatch({ type: 'STOP EDITING WIDGET' });

        // Can't wait until the next update for the data to update.
        SalesTv.updateSlideData();
    }

    static nextSlide() {
        reducerStore.dispatch({ type: 'NEXT SLIDE' });
    }

    static previousSlide() {
        reducerStore.dispatch({ type: 'PREVIOUS SLIDE' });
    }

    static goToSlide(slideIndex) {
        reducerStore.dispatch({ type: 'GO TO SLIDE', id: slideIndex });
    }

    static createWidget() {
        SalesTv.startEditing(null);
    }

    static handleNotification(data, threshold = 0) {
        axios.get(`/api/notification/${data.notificationId}`).then((notification) => {
            // TODO: Refine the handling of notifications.
            if (notification.data.type === 'Order' && notification.data.order.orderValue > threshold) {
                reducerStore.dispatch({ type: 'CURRENT NOTIFICATION', data: notification.data });

                SalesTv.updateSlideData();

                setTimeout(() =>
                    reducerStore.dispatch({ type: 'DISABLE NOTIFICATION' }), 20 * 1000);
            }
        }).catch(error => console.log(error));
    }

    constructor(props) {
        super(props);

        this.state = {
            currentSlide: '',
            intervalId: null,
            isEditingWidget: false,
            editingWidget: null,
            clientId: null,
            slides: [],
            slidesData: [],
            editId: null,
            isEditing: false,
            slidesToShow: [],
            companyProfile: {
                colors: {
                    mainBg: '#ffffff',
                },
                logo: '',
            },
            slideInterval: 10,
            notificationThreshold: 0,
            pusher: null,
            currentNotification: null,
            loadingDone: false,
            slideShowInterval: null,
            currencyIso: '',
            wasFullscreen: false,
            tvIndex: null,
        };

        this.slideInterval = null;
        this.clientSideJsInterval = null;

        this.unsubscribeFromReducer = null;

        this.startSlideshow = this.startSlideshow.bind(this);
        this.stopSlideshow = this.stopSlideshow.bind(this);
        this.authPusher = this.authPusher.bind(this);
        this.checkForJsUpdates = this.checkForJsUpdates.bind(this);
        this.handleWasFullscreen = this.handleWasFullscreen.bind(this);
        this.goFullScreen = this.goFullScreen.bind(this);
        this.moveToTv = this.moveToTv.bind(this);
        this.reorderDone = this.reorderDone.bind(this);
        this.stopEditing = this.stopEditing.bind(this);
        this.editSlide = this.editSlide.bind(this);
        this.updateTvNames = this.updateTvNames.bind(this);
    }

    componentDidMount() {
        this.unsubscribeFromReducer =
            reducerStore.subscribe(this.handleStateChange.bind(this));

        Promise.all([
            axios.get('/api/salestv/'),
            axios.get('/api/salestv/force-update'),
            axios.get('/api/companyProfile'),
            axios.get('/api/metadata'),
            this.getCustomWidgets(),
        ]).then(([tvConfig, tvData, companyProfile, metadata, customWidgets]) => {
            const upsalesCompanyProfile = {
                colors: companyProfile.data.colors,
                extraColors: companyProfile.data.extraColors,
                logo: companyProfile.data.logo,
            };

            const defaultCompanyProfile = {
                colors: { mainBg: '#002f65' },
                extraColors: null,
                logo: null,
            };

            const currency = _.find(metadata.data.customerCurrencies, obj =>
                obj.masterCurrency === true);

            const profile = tvConfig.data.useCompanyProfileColors ?
                upsalesCompanyProfile : defaultCompanyProfile;

            const sortedSlides = _.orderBy(tvConfig.data.slides, 'position', 'asc');

            reducerStore.dispatch({
                type: 'SET SLIDES',
                data: sortedSlides,
                clientId: tvConfig.data.clientId,
                companyProfile: profile,
                companyOptions: companyProfile.data,
                slideInterval: tvConfig.data.slideInterval || this.state.slideInterval,
                notificationThreshold: tvConfig.data.notificationThreshold || this.state.notificationThreshold,
                useCompanyProfile: tvConfig.data.useCompanyProfileColors,
                licenses: tvConfig.data.licenses,
                tvNames: tvConfig.data.tvNames || [],
            });

            reducerStore.dispatch({
                type: 'SET SLIDES DATA',
                data: tvData.data,
            });

            reducerStore.dispatch({
                type: 'SET CURRENCY',
                currency: currency.iso,
            });

            reducerStore.dispatch({
                type: 'SET CUSTOM WIDGETS',
                customWidgets: _.map(customWidgets, (widget) => ({
                    id: widget._id,
                    name: widget.name,
                    target: widget.endpoint,
                }))
            });

            Raven.setUserContext({
                id: metadata.data.user.id,
                clientId: tvConfig.data.clientId
            });

            if (tvConfig.data.licenses === 1) {
                const firstSlide = _.first(sortedSlides);
                if (firstSlide && firstSlide.tvIndex) {
                    reducerStore.dispatch({
                        type: 'CHANGE CHANNEL',
                        tvIndex: firstSlide.tvIndex
                    });
                }
            }

        }).catch((error) => {
            console.log(error);

            throw error;
        });

        this.slideInterval = setInterval(SalesTv.updateSlideData, this.state.slideInterval * 1000);

        this.clientSideJsInterval = setInterval(this.checkForJsUpdates, 24 * 60 * 60 * 1000);

        this.authPusher();

        if (this.props.location.query.playing === 'true') {
            this.startSlideshow();
        }

        if (this.props.location.query.fullscreen === 'true') {
            this.handleWasFullscreen();
        }
    }

    componentWillMount() {
        this.unsubscribeFromReducer =
            reducerStore.subscribe(this.handleStateChange.bind(this));

        this.handleStateChange();
    }

    componentWillUnmount() {
        if (this.state.slideShowInterval) this.stopSlideshow();

        if (this.slideInterval) clearInterval(this.slideInterval);

        if (this.unsubscribeFromReducer) this.unsubscribeFromReducer();

        if (this.clientSideJsInterval) clearInterval(this.clientSideJsInterval);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.slideInterval !== this.state.slideInterval && this.state.slideShowInterval) {
            clearInterval(this.state.slideShowInterval);
            this.startSlideshow();
        }
    }

    getCustomWidgets() {
        return axios.get('/api/customWidgets/list').then((res) => {
            return res.data;
        }).catch((err) => {
            return [];
        })
    }

    handleWasFullscreen() {
        this.setState({
            wasFullscreen: true,
        });
    }

    goFullScreen() {
        console.log(this.props);
        SalesTv.launchPresentationMode();
        this.setState({
            wasFullscreen: false,
        });
    }

    handleStateChange() {
        const newState = reducerStore.getState();
        this.setState(newState);
    }

    authPusher() {
        async.parallel({
            metadata: async.apply(SalesTv.getMetadata, this.state.clientId),
        }, (err, res) => {
            const pusher = new Pusher(config.pusher.key, {
                authEndpoint: 'api/authPusher/',
                encrypted: true,
                socket_id: `${this.state.clientId}.0`,
                channel_name: res.metadata.notificationChannel,
            });

            const channel = pusher.subscribe(res.metadata.notificationChannel);

            channel.bind('notificationObject', (data) => { SalesTv.handleNotification(data, this.state.notificationThreshold); });
        });
    }

    forceRunNotification(id) {
        SalesTv.handleNotification({ notificationId: id }, this.state.notificationThreshold);
    }

    reorderDone(reorderedArray) {
        const { slides } = this.state;

        const needToUpdate = reorderedArray.filter((slide, index) =>
            slides[index].id !== slide.id ||
            slides[index].position !== slide.position ||
            slides[index].tvIndex !== slide.tvIndex);

        if (needToUpdate.length === 0) return;

        // Only send PUTs for the ones that need to be updated.
        needToUpdate.forEach((slide) => {
            // Update the reducer state with the new positions.
            reducerStore.dispatch({ type: 'SLIDE SAVED', slide });

            axios.put(`/api/salestv/${slide.id}`, slide).catch(error => console.log(error));
        });
    }

    stopEditing() {
        const states = { slide: null, editId: null, isEditing: false };
        reducerStore.dispatch({ type: 'STOP EDIT', states });
    }

    moveToTv(slideId, newTvId, index) {
        const { slides } = this.state;

        const tv = _.find(slides, ['id', slideId]);

        tv.tvIndex = newTvId;

        const slidesPerTv = _.groupBy(slides, slide => (_.get(slide, 'tvIndex', 0)));

        const newPositions = slides.map((slide) => {
            let position = _.findIndex(slidesPerTv[slide.tvIndex || 0], ['id', slide.id]);
            if (slide.tvIndex === newTvId && position >= index) {
                position += 1;
            }
            return Object.assign({}, slide, { position });
        });

        const newTv = _.find(newPositions, ['id', slideId]);

        newTv.position = index;
        newTv.inactive = 0;

        const needToUpdate = newPositions.filter((slide, theIndex) =>
            slides[theIndex].position !== slide.position ||
            (slides[theIndex].tvIndex || 0) !== slide.tvIndex);

        // The one that was just moved needs to be updated
        needToUpdate.push(newTv);

        if (needToUpdate.length === 0) return;

        // Only send PUTs for the ones that need to be updated.
        needToUpdate.forEach((slide) => {
            // Update the reducer state with the new positions.
            reducerStore.dispatch({ type: 'SLIDE SAVED', slide });

            axios.put(`/api/salestv/${slide.id}`, slide).catch(error => console.log(error));
        });
    }

    updateTvNames(index, name) {
        const { tvNames } = this.state;

        tvNames[index] = name;

        reducerStore.dispatch({ type: 'TV NAMES UPDATED', tvNames });

        axios.put('/api/salestv/tvNames', { tvNames }).catch(error => console.log(error));
    }

    startSlideshow(fullscreen) {
        this.setState({
            slideShowInterval: setInterval(SalesTv.nextSlide, this.state.slideInterval * 1000),
        });
        if (fullscreen) {
            SalesTv.launchPresentationMode();
        }
    }

    stopSlideshow() {
        clearInterval(this.state.slideShowInterval);

        this.setState({
            slideShowInterval: null,
        });
    }

    editSlide(slide) {
        const { slides, currentSlideId } = this.state;
        if (!slide) {
            slide = _.find(slides, { id: currentSlideId })
        }

        if (slide.type === 'competition') {
            reducerStore.dispatch({ type: 'EDITING WIDGET', editingWidget: 'competition' });
        } else {
            reducerStore.dispatch({ type: 'EDIT SLIDE', states: { isEditing: true, slide, editId: slide.id } });
        }
    }

    checkForJsUpdates() {
        if (!window.loadedVersionOfSalesTv) return;

        axios.get('/api/clientSideJsVersion').then((res) => {
            if (res.data.version !== window.loadedVersionOfSalesTv) {
                const isFullscreen = document.fullscreenElement ||
                    document.msFullscreenElement ||
                    document.mozFullScreenElement ||
                    document.webkitFullscreenElement;
                const params = [`playing=${this.state.slideShowInterval !== null}`,
                `fullscreen=${isFullscreen ? 'true' : 'false'}`];
                window.open(`${window.location.protocol}//${window.location.host}` +
                    `${window.location.pathname}?${params.join('&')}`, '_self');

            }
        }).catch((e) => {
            console.log('Could not fetch latest version of client side JS', e);
        });
    }

    render() {
        const {
            clientId,
            companyProfile,
            companyOptions,
            currencyIso,
            currentSlideId,
            licenses,
            slides,
            editId,
            isEditing,
            editingWidget,
            isEditingWidget,
            slide,
            slidesData,
            slideInterval,
            slideShowInterval,
            showSettingsModal,
            showChannelsModal,
            notificationThreshold,
            tvIndex,
            tvNames,
            overviewTabIndex,
            wasFullscreen,
            useCompanyProfile,
            openPicker,
            customWidgets,
        } = this.state;

        if (!clientId) {
            return (
                <div className="loading">
                    Loading
                    <i className="fa fa-refresh fa-spin fa-fw" aria-hidden="true" />
                </div>
            );
        }

        let showOverView = null;
        let hasUpdated = null;

        if (wasFullscreen === true) {
            hasUpdated = (
                <div className="wasFullScreen">
                    <p>Ny uppdatering</p>
                    <button onClick={this.goFullScreen}>Återgå till helskärmsläget</button>
                </div>
            );
        }

        const overviewModal = (tvIndex && <OverviewModal
            hideModal={!!this.state.slideShowInterval || this.state.isEditingWidget}
            clientId={clientId}
            currentSlideId={currentSlideId}
            slides={slides}
            editSlide={this.editSlide}
            goToSlide={SalesTv.goToSlide}
            slidesData={slidesData}
            tvIndex={tvIndex}
            tvNames={tvNames}
            updateTvNames={this.updateTvNames}
            licenses={licenses}
            overviewTabIndex={overviewTabIndex}
            companyProfile={companyProfile}
            currency={currencyIso}
            useCompanyProfile={useCompanyProfile}
            slideInterval={slideInterval}
            notificationThreshold={notificationThreshold}
        />);

        const slideSettingsModal = (isEditing && tvIndex && <SlideSettingsModal
            isEditing={isEditing}
            editId={editId}
            currentSlideId={currentSlideId}
            stopEditing={this.stopEditing}
            slide={slide}
            slides={slides}
            companyProfile={companyProfile}
            companyOptions={companyOptions}
            showPicker={openPicker}
            tvIndex={tvIndex}
        />);

        const chooseChannelsModal = (showChannelsModal && <ChannelsModal
            companyProfile={companyProfile}
            currency={currencyIso}
            currentSlideId={currentSlideId}
            licenses={licenses}
            slides={slides}
            slidesData={slidesData}
            startSlideshow={this.startSlideshow}
            tvNames={tvNames}
            tvIndex={tvIndex}
            updateTvNames={this.updateTvNames}
        />);

        const generalSettingsModal = (showSettingsModal && <GeneralSettingsModal
            useCompanyProfile={useCompanyProfile}
            currency={currencyIso}
            slideInterval={slideInterval}
            notificationThreshold={notificationThreshold}
            clientId={clientId}
        />);

        return (
            <div
                ref={(node) => { this.node = node; }}
                style={{ background: companyProfile.colors.mainBg }}
            >
                {tvIndex && <div className="gradient-background">
                    <div className="salesTv" style={{ height: '100%', width: '100%' }}>
                        {slides.map(slide => {
                            if (slide.type === 'competition') {
                                return <CompetitionSlide
                                    key={slide.id}
                                    ref={slide.id}
                                    parent={this.node}
                                    slide={slide}
                                    slidesData={slidesData}
                                    currency={currencyIso}
                                    slideId={slide.id}
                                    active={slide.id === currentSlideId}
                                    isPlaying={slideShowInterval !== null}
                                    isEditingWidget={isEditingWidget}
                                    startEditing={SalesTv.startEditing}
                                    companyProfile={companyProfile}
                                />
                            }

                            return <Slide
                                key={slide.id}
                                ref={slide.id}
                                parent={this.node}
                                slide={slide}
                                slidesData={slidesData}
                                currency={currencyIso}
                                slideId={slide.id}
                                active={slide.id === currentSlideId}
                                isPlaying={slideShowInterval !== null}
                                isEditingWidget={isEditingWidget}
                                startEditing={SalesTv.startEditing}
                                companyProfile={companyProfile}
                            />;
                        }
                        )}
                        <SlideIndicator
                            showIndicator={this.state.slideShowInterval}
                            slides={slides}
                            currentSlideId={currentSlideId}
                            goToSlide={SalesTv.goToSlide}
                            tvIndex={tvIndex}
                        />
                        <Controls
                            isPlaying={slideShowInterval !== null}
                            nextSlide={SalesTv.nextSlide}
                            previousSlide={SalesTv.previousSlide}
                            startSlideshow={this.startSlideshow}
                            stopSlideshow={this.stopSlideshow}
                            editCurrentSlide={this.editSlide}
                            createWidget={SalesTv.createWidget}
                        />
                        {this.state.isEditingWidget === true &&
                            <SettingsModal
                                slides={slides}
                                stopEditing={SalesTv.stopEditing}
                                editingSlide={currentSlideId}
                                editingWidget={editingWidget}
                                customWidgets={customWidgets}
                                tvIndex={tvIndex}
                            />
                        }
                        <Notification data={this.state.currentNotification} />
                        <div className="upsales-logo-holder">
                            <UpsalesLogo />
                        </div>
                        {hasUpdated}
                    </div>
                </div>}
                {overviewModal}
                {slideSettingsModal}
                {chooseChannelsModal}
                {generalSettingsModal}
            </div>
        );
    }
}

SalesTv.propTypes = {
    params: React.PropTypes.shape({
        tvIndex: React.PropTypes.string,
    }),
    location: React.PropTypes.shape({
        query: React.PropTypes.shape({
            playing: React.PropTypes.string,
            fullscreen: React.PropTypes.string,
        }),
    }),
    router: React.PropTypes.shape({
        push: React.PropTypes.function,
    }),
};

export default DragDropContext(HTML5Backend)(SalesTv);



/** WEBPACK FOOTER **
 ** ./client/components/SalesTv/SalesTv.jsx
 **/